import { useEffect } from "react";

import { GO_TO_CLIENT_DETAIL } from "../../../../../../src/globalConstants";

const useGoClientDetail = (id, location, path, isClientDetailPage) => {
  useEffect(() => {
    if (location.state?.from === "document-search" && isClientDetailPage) {
      sessionStorage.setItem(GO_TO_CLIENT_DETAIL, id);
    }
  }, [location.state, id, path]);

  const storedId = sessionStorage.getItem(GO_TO_CLIENT_DETAIL);
  const isFromDocumentSearch = storedId === String(id) && location.state?.from !== "client-detail";

  useEffect(() => {
    return () => {
      if (!isClientDetailPage) {
        sessionStorage.removeItem(GO_TO_CLIENT_DETAIL);
      }
    };
  }, [path]);

  return isFromDocumentSearch;
};

export default useGoClientDetail;
